module.exports = __webpack_public_path__ + "static/askneo-logo-5bf88ba0e3517d78fd8b6333678ce559.png";